import { render, staticRenderFns } from "./base_icon.vue?vue&type=template&id=214d5282&scoped=true&"
import script from "./base_icon.vue?vue&type=script&lang=js&"
export * from "./base_icon.vue?vue&type=script&lang=js&"
import style0 from "./base_icon.vue?vue&type=style&index=0&id=214d5282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d5282",
  null
  
)

export default component.exports